import React from 'react';

import s from '../styles/Access.module.css';
import tabPanel from '../styles/TabPanel.module.css';
import { CourseProps } from '../props';
import { cleanCourseName } from '@Util/util';
import Heading2 from '@Components/heading_2/view';

const GOOGLE_MAP_API_KEY = process.env.GOOGLE_MAP_API_KEY;

type AccessProps = {
    show: boolean;
    course: CourseProps;
    courseName: string;
    highwayInformation: string;
    lineInformation: string[];
};
export const Access = (props: AccessProps) => {
    // 地図の埋め込みは、タブが一度開かれるまでDOMに出さない。
    // display:none 配下の iframe を loading='lazy' が読み込まないのはブラウザの実装依存で
    // 仕様上の保証がなく（Safari 15.1 以前は loading 属性自体が非対応）、常時マウントにすると
    // タブを開かない利用者にも Google Maps へのリクエストが飛びうる。
    // 住所・アクセス表（SEOで必要な部分）は常にDOMへ出す
    const [hasBeenShown, setHasBeenShown] = React.useState(props.show);

    React.useEffect(() => {
        if (props.show) setHasBeenShown(true);
    }, [props.show]);

    return (
        <div className={`${s.container} ${props.show ? '' : tabPanel.tab_panel_hidden}`}>
            <Heading2 title={`${cleanCourseName(props.courseName)}への交通アクセス`} />
            <div className={s.head_2_body}>
                <table className={s.access_table}>
                    <tbody>
                        <tr>
                            <th>住所</th>
                            <td>
                                <p className={s.access_table_item}>
                                    &#12306;{props.course.zipcode} {props.course.address}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <th>自動車</th>
                            <td>
                                <p className={s.access_table_item}>{props.highwayInformation || '-'}</p>
                            </td>
                        </tr>
                        <tr>
                            <th>電車</th>
                            <td>
                                <p className={s.access_table_item}>{props.lineInformation || '-'}</p>
                            </td>
                        </tr>
                        <tr>
                            <th>クラブバス</th>
                            <td>{props.course.hasClubBus ? '有' : '無'}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Heading2 title={`${cleanCourseName(props.courseName)}のマップ`} />
            <div className={s.head_2_body}>
                <p className={s.address}>
                    &#12306;{props.course.zipcode} {props.course.address}
                </p>
                {hasBeenShown && (
                    <iframe
                        src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAP_API_KEY}&q=${props.course.address}`}
                        className={s.google_map_frame}
                        loading='lazy'
                    ></iframe>
                )}
            </div>
        </div>
    );
};

export default Access;
